<script setup lang="ts">
import { useAuthProcessStore } from '#imports';

const service = useAuthProcessStore();

const form = ref();

async function onSubmit() {
  form.value.clear();
  await service.login(errors => setBackendErrors(form.value, errors));
}
</script>

<template>
  <UForm
    ref="form"
    :schema="service.loginSchema()"
    :state="service.data"
    :validate-on="['submit']"
    class="space-y-4"
    @submit="onSubmit"
  >
    <UCard>
      <template #header>
        <slot name="header" />
      </template>
      <UFormGroup :label="$t('auth.email')" required name="email">
        <UInput v-model="service.data.email" icon="i-heroicons-envelope" :placeholder="$t('auth.emailPlaceholder')" />
      </UFormGroup>

      <UFormGroup :label="$t('auth.password')" required name="password" class="mt-2">
        <template #hint>
          <UButton
            :icon="service.showPassword ? 'i-heroicons-eye' : 'i-heroicons-eye-slash'"
            size="sm"
            color="primary"
            square
            variant="ghost"
            @click="service.togglePasswordVisible()"
          />
        </template>
        <UInput
          v-model="service.data.password"
          icon="i-heroicons-finger-print"
          :type="service.passwordInputType"
        />
      </UFormGroup>

      <template #footer>
        <div class="flex items-center">
          <UButton type="submit" icon="i-bi-box-arrow-in-right" :loading="service.loading">
            {{ $t('auth.submitLogin') }}
          </UButton>
          <UButton :to="useUrlWithRedirect('/auth/register')" class="ml-2" variant="link" :disabled="service.loading">
            {{ $t('auth.linkToRegister') }}
          </UButton>
          <UButton to="/auth/password/recovery" class="ml-1" variant="link" :disabled="service.loading">
            {{ $t('auth.linkToRecoveryPassword') }}
          </UButton>
        </div>
      </template>
    </UCard>
  </UForm>
</template>
